import MainLayout from '@/lib/layout/MainLayout';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/terms-of-service')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <MainLayout.Header headline="Terms of Service"></MainLayout.Header>
      <MainLayout.Content>
        {/* --- Full Terms of Service --- */}

        {/* 1. Applicability */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">1. Applicability</h3>
          <p>
            The website <span className="font-semibold">wouldu.io</span>{' '}
            (hereinafter “we,” “us,” or “our”) is operated by a private
            individual (site owner). By using wouldu.io, you agree to these
            Terms of Service. If you do not agree, you may not use the platform.
          </p>
        </div>

        {/* 2. Description of the Service */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">
            2. Description of the Service
          </h3>
          <p>
            wouldu.io is a social platform that allows users to create and share{' '}
            <em>Would You Rather</em> questions (“polls”) and discuss them with
            other users. Some features may require creating an account, while
            basic browsing is available without registration.
          </p>
        </div>

        {/* 3. User Responsibilities */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">3. User Responsibilities</h3>
          <ul className="list-inside list-disc space-y-1">
            <li>Comply with all applicable laws and regulations.</li>
            <li>Do not post content that is illegal, offensive, or harmful.</li>
            <li>
              Do not infringe on intellectual property, privacy, or other rights
              of others.
            </li>
            <li>Do not upload malware, spam, or other malicious content.</li>
            <li>
              You are responsible for securing your account and reporting any
              unauthorized use.
            </li>
          </ul>
        </div>

        {/* 4. License & Limitations */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">4. License & Limitations</h3>
          <p>
            We grant you a personal, non-exclusive, revocable license to use
            wouldu.io in accordance with these Terms. You may not decompile,
            reverse engineer, or misuse the platform in any way.
          </p>
        </div>

        {/* 5. Intellectual Property */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">5. Intellectual Property</h3>
          <p>
            All rights to the website, software, and design remain with the site
            operator. You retain ownership of the content you post but grant us
            a license to display and distribute it within the platform for as
            long as it is available online.
          </p>
        </div>

        {/* 6. Privacy */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">6. Privacy</h3>
          <p>
            We process personal data as described in our{' '}
            <Link to="/privacy" className="text-primary underline">
              Privacy Policy
            </Link>
            .
          </p>
        </div>

        {/* 7. Support & Updates */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">7. Support & Updates</h3>
          <p>
            We may update wouldu.io to improve features or fix issues. Support
            is available via email at{' '}
            <a
              href="mailto:contact@wouldu.io"
              className="text-primary underline"
            >
              contact@wouldu.io
            </a>
            .
          </p>
        </div>

        {/* 8. Limitation of Liability */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">8. Limitation of Liability</h3>
          <p>
            wouldu.io is provided “as is.” To the fullest extent permitted by
            law, we disclaim all warranties and are not liable for indirect
            damages, including lost data, downtime, or user content.
          </p>
        </div>

        {/* 9. Changes */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">9. Changes to the Terms</h3>
          <p>
            We may update these Terms of Service from time to time. Significant
            changes will be communicated on the platform. Continued use of the
            service after changes means you accept the updated Terms.
          </p>
        </div>

        {/* 10. Contact */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">10. Contact</h3>
          <p>For questions or concerns, please contact us at:</p>
          <ul className="list-inside list-disc">
            <li>Email: contact@wouldu.io</li>
          </ul>
        </div>
      </MainLayout.Content>
    </>
  );
}
